import { configureStore } from '@reduxjs/toolkit';
// Import slices here as you create them
import authReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice';
import productReducer from './slices/productSlice';
import orderReducer from './slices/orderSlice';
import paymentReducer from './slices/paymentSlice';
import ticketReducer from './slices/ticketSlice';
import blogReducer from './slices/blogSlice';
import { cartSyncMiddleware } from './middleware/cartSyncMiddleware';

export const store = configureStore({
  reducer: {
    // Add your reducers here
    auth: authReducer,
    cart: cartReducer,
    products: productReducer,
    orders: orderReducer,
    payment: paymentReducer,
    tickets: ticketReducer,
    blogs: blogReducer,
  },
  // Enable Redux DevTools in development
  devTools: import.meta.env.DEV,
  // Optional: Add middleware here if needed
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // Ignore these field paths in all actions
        ignoredActionPaths: [],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }).concat(cartSyncMiddleware),
});

// Export types for TypeScript (if you migrate to TS later)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

// Export store instance for direct access when needed
export default store;

